<template>
  <div :class="['shop-discount-wrapper', { disabled: disabled }]">
    <div ref="scroll" class="scroll-box">
      <div v-if="couponTags.length" class="coupon-box">
        <Coupon
          v-for="(coupon, couponKey) in couponTags"
          :key="'coupon' + couponKey"
          class="item"
          :info="coupon"
        />
        <div class="empty"></div>
      </div>
      <div
        v-if="tags.length"
        :class="['tag-box', { 'has-coupon': couponTags.length }]"
      >
        <Tag
          v-for="(tag, tagKey) in tags"
          :key="tagKey"
          class="item"
          :tag="tag"
        />
        <div class="empty"></div>
      </div>
    </div>
    <transition name="fadeIn">
      <div v-show="showMore" class="more-box">
        <i class="icon-v3_small_outlined_entrance"></i>
      </div>
    </transition>
  </div>
</template>

<script>
import Coupon from './coupon.vue';
import Tag from './tag.vue';
export default {
  name: 'ShopTopDiscount',
  components: {
    Coupon,
    Tag,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
      default: () => [],
    },
    couponTags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showMore: false,
    };
  },
  mounted() {
    this.bindScroll();
  },
  methods: {
    bindScroll() {
      this.$refs.scroll.addEventListener('scroll', this.onScroll);
    },
    onScroll() {
      let scrollLeft = this.$refs.scroll?.scrollLeft;
      if (scrollLeft <= 0) {
        this.showMore = false;
      } else if (!this.showMore && scrollLeft > 30) {
        this.showMore = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.shop-discount-wrapper {
  position: relative;
  &.disabled {
    opacity: 0.5;
  }
}
.scroll-box {
  padding-left: rem(32);
  width: 100vw;
  overflow-y: hidden;
  overflow-x: scroll;
}
.scroll-box::-webkit-scrollbar {
  display: none;
}
.coupon-box,
.tag-box {
  display: flex;
  font-size: 0;
  .empty {
    flex-shrink: 0;
    width: rem(88);
  }
  .item {
    flex-shrink: 0;
    margin-right: rem(20);
  }
}
.tag-box {
  flex-shrink: 0;
  &.has-coupon {
    margin-top: rem(20);
  }
}
.more-box {
  position: absolute;
  right: 0;
  top: 0;
  padding-left: rem(40);
  height: 100%;
  width: rem(100);
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    #ffffff rem(32)
  );
  i {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    height: rem(28);
    font-size: rem(28);
    vertical-align: middle;
  }
}

.fadeIn-enter-active {
  opacity: 0;
  animation: fadeIn 0.2s linear;
}
.fadeIn-leave-active {
  animation: fadeIn 0.2s linear reverse;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media screen and (min-width: 768px) {
  .scroll-box {
    padding-left: 0;
    width: 100%;
  }
}
</style>
